import { reducerWithInitialState } from "typescript-fsa-reducers";
import { resetAlertBanner, showAlertBanner } from "./actions";

export enum ALERT_BANNER_TYPES {
  ERROR = "error",
  WARNING = "warning",
  SUCCESS = "success",
  INFO = "info"
}

export interface OpenAlertBanner {
  type: ALERT_BANNER_TYPES;
  message: string;
}

export type InitialAlertBanner = null;

export type AlertBannerState = InitialAlertBanner | OpenAlertBanner;

const alertBannerReducer = reducerWithInitialState<Readonly<AlertBannerState>>(
  null
)
  .case(showAlertBanner, (state, payload) => payload)
  .case(resetAlertBanner, () => null);

export default alertBannerReducer;



// WEBPACK FOOTER //
// ./src/shared/alertBanner/reducer.ts